export const BcEhtHeaderColumns = [
	{
		field: "dueDate",
		headerName: "Due Date",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "dueAmount",
		headerName: "Due Amount",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "right",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "remitAmount",
		headerName: "Remit Amount",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "right",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 2,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "chequeNo",
		headerName: "Cheque No.",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "chequeDate",
		headerName: "Cheque Date",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "remitButton",
		headerName: "",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
]